import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

export const getRepairsListApi = async (data) => {
  return await api.get(
    `/defect/list?department_id=${data?.department_id}&vessel_id=${data?.vessel_id}&startDate=${data?.startDate}&endDate=${data?.endDate}&limit=${data?.limit}&offset=${data?.offset}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getRepairDefectsDetailListByIdApi = async (id) => {
  return await api.get(`/defect/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};
